import React from "react";
import Header from "./../Header";
import Sidebar from "./../Sidebar";
import OutstandingReminderTemplate from "./OutstandingReminderTemplate";
import Footer from "./../Footer";
const OutstandingReminder = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <OutstandingReminderTemplate />
      <Footer />
    </>
  );
};

export default OutstandingReminder;
